/**
 * 장바구니 품목 수를 `.judahs.io` 쿠키에 비춘다. forum.judahs.io 헤더의 Cart 배지가 이 값을 읽는다
 * (forum-theme `jd-nav.js`, PENDING_CHANGES §31). 장바구니 자체는 그대로 localStorage `cart` 에 있다.
 * 장바구니를 위한 필수 쿠키라 동의 대상이 아니다 (Privacy Policy "Essential cookies").
 */
const COOKIE_NAME = 'judahs_cart_count'
const COOKIE_MAX_AGE = 60 * 60 * 24 * 395
const SHARED_DOMAIN = 'judahs.io'

/** localhost 에서는 도메인을 붙이지 않는다 — 붙이면 브라우저가 쿠키를 버린다 */
const cookieDomainPart = (): string => {
	const host = window.location.hostname
	return host === SHARED_DOMAIN || host.endsWith(`.${SHARED_DOMAIN}`)
		? `; domain=.${SHARED_DOMAIN}`
		: ''
}

export const CartCookie = {
	/** 네비가 장바구니를 다시 셀 때마다 부른다. 0 이면 지운다 */
	sync: (count: number): void => {
		const domainPart = cookieDomainPart()

		if (count <= 0) {
			if (document.cookie.includes(`${COOKIE_NAME}=`)) {
				document.cookie = `${COOKIE_NAME}=; Max-Age=0; path=/${domainPart}`
			}
			return
		}

		const secure = window.location.protocol === 'https:' ? '; Secure' : ''
		document.cookie = `${COOKIE_NAME}=${count}; Max-Age=${COOKIE_MAX_AGE}; path=/${domainPart}; SameSite=Lax${secure}`
	},
}
